"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _actions = require("../actions");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};
class ShowMe extends _react.default.Component {
  componentDidMount() {
    if (!this.props.auth.me.fetched) this.props.get({
      expand: 'FlatPermissions'
    });
  }
  render() {
    const {
      auth,
      children,
      ...rest
    } = this.props;
    return _react.default.cloneElement(children, {
      ...rest,
      me: auth.me
    });
  }
}
ShowMe.propTypes = process.env.NODE_ENV !== "production" ? {
  get: _propTypes.default.func,
  auth: _propTypes.default.object,
  children: _propTypes.default.object
} : {};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  get: _actions.getMe
})(ShowMe);
module.exports = exports.default;